module.exports = __webpack_public_path__ + "static/img/phone-01-copy-10.0402ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/phone-01-copy-10.png
// module id = NdKo
// module chunks = 1